import * as React from 'react';
export const IcCutScissor = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.69 5.72a1 1 0 00-1.38-1.44l-3.49 3.33L16 3.25a1.031 1.031 0 00-2-.5l-2 7.51-2.19 2.15A3.43 3.43 0 009 11a3.58 3.58 0 00-5 0 3.5 3.5 0 002.5 6A3.51 3.51 0 009 16l2.13-2-1 3.68a3.5 3.5 0 003.39 4.39 3.5 3.5 0 003.37-2.59 3.51 3.51 0 00-2.47-4.29 3.442 3.442 0 00-1.56 0l1-3.81 5.83-5.66zM5.44 14.56a1.5 1.5 0 010-2.12 1.498 1.498 0 012.488.46 1.5 1.5 0 01-.368 1.66 1.53 1.53 0 01-2.12 0zm8.45 2.53a1.51 1.51 0 11-1.063 2.827 1.51 1.51 0 011.063-2.827z'
      fill='currentColor'
    />
  </svg>
);
